import { render, staticRenderFns } from "./waitSigned.vue?vue&type=template&id=3748a678&"
import script from "./waitSigned.vue?vue&type=script&lang=js&"
export * from "./waitSigned.vue?vue&type=script&lang=js&"
import style0 from "./waitSigned.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports